import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'secondary' | 'accent' | 'danger';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  block?: boolean;
  children: ReactNode;
};

const styles: Record<Variant, React.CSSProperties> = {
  primary: {
    background: 'var(--color-green-700)',
    color: 'var(--color-white)',
    border: '1px solid var(--color-green-700)',
  },
  secondary: {
    background: 'var(--bg-surface)',
    color: 'var(--color-green-700)',
    border: '1px solid var(--color-green-700)',
  },
  accent: {
    background: 'var(--color-yellow-500)',
    color: 'var(--color-green-900)',
    border: '1px solid var(--color-yellow-700)',
    fontWeight: 700,
  },
  danger: {
    background: 'var(--color-danger)',
    color: 'var(--color-white)',
    border: '1px solid var(--color-danger)',
  },
};

export function Button({ variant = 'primary', block, style, children, ...rest }: Props) {
  return (
    <button
      {...rest}
      style={{
        padding: '10px 16px',
        borderRadius: 'var(--radius-sm)',
        cursor: 'pointer',
        fontWeight: 600,
        width: block ? '100%' : undefined,
        ...styles[variant],
        ...style,
      }}
    >
      {children}
    </button>
  );
}
